import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';

import Spinner from 'components/Spinner';
import H2 from 'components/deprecated/legacyElements/H2';
import TopPostsQuery from 'queries/TopPostsQuery.gql';
import TopPostCard from './TopPostCard';

import styles from './style.module.scss';

class BetterCompanyCultureSection extends Component {
  render() {
    const topPosts = [];
    if (this.props.data.cmsPosts) {
      topPosts.push(...this.props.data.cmsPosts);
    } else {
      return null;
    }

    return (
      <section className={styles.betterCompanyCultureSection}>
        <div className="inset">
          <H2>For a better company&nbsp;culture</H2>
          <div className={styles.topPostCardContainer}>
            {this.props.data.loading && <Spinner floating />}
            {this.props.data.error && <p>Error! {this.props.data.error}</p>}
            {topPosts.map((post, index) => (
              <TopPostCard
                key={post.title}
                className={index === 0 ? '' : 'desktop-only'}
                topPost={post}
              />
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default graphql(TopPostsQuery, {
  options: () => ({
    variables: {
      numberOfPosts: 3,
      tag: 185,
    },
  }),
})(BetterCompanyCultureSection);
